import { defer } from "react-router-dom";
import { resolveLoaderResult } from "@/routes/loaderResult";
import { getSelectPage } from "../common/service";
import { USE_MOCK, MOCK_PAGE_INFO } from "./mock";

// TODO: 联调期 mock，看完页面改回真实请求（删掉 mock 分支，恢复 getSelectPage()）
export function limitSelectLoader() {
  return defer({
    coreData: resolveLoaderResult(
      USE_MOCK ? Promise.resolve(MOCK_PAGE_INFO) : getSelectPage()
    ),
  });
}
